import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { AbstractDialogComponent } from '../abstract-dialog-component.directive';
import { SolDialogComponent } from '../sol-dialog/sol-dialog.component';
import { SolFormComponent } from '../../form/sol-form/sol-form.component';
import { SolLayoutComponent } from '../../core/sol-layout/sol-layout.component';
import { SolForm } from '../../../models/form/sol-form';
import { SolValidationMessage } from '../../../models/core/sol-validation-message';
import { SolSelectAddValueDialogState, SolSelectAddValueFormData } from './sol-select-add-value-dialog.state';

@Component({
  selector: 'sol-select-add-value-dialog',
  standalone: true,
  imports: [SolDialogComponent, SolFormComponent, SolLayoutComponent],
  templateUrl: './sol-select-add-value-dialog.component.html',
})
export class SolSelectAddValueDialogComponent
  extends AbstractDialogComponent<SolSelectAddValueDialogState>
  implements AfterViewInit
{
  // Computed
  protected readonly dialog$ = this.compute(state => state.dialog);
  protected readonly form$ = this.compute(state => state.form);

  // Result
  public onValueAdded: (value: string) => void = () => {};

  // Binding
  @ViewChild('formRef')
  private formRef?: SolFormComponent<SolSelectAddValueFormData>;

  constructor() {
    super(SolSelectAddValueDialogState.of());
  }

  ngAfterViewInit(): void {
    this.formRef?.focus();
  }

  public showErrors(messages: SolValidationMessage[]): void {
    this.update(state => state.withErrors(messages));
  }

  protected onFormChange(form: SolForm<SolSelectAddValueFormData>): void {
    this.update(state => state.withForm(form));
  }

  protected handleConfirm(): void {
    this.update(state => state.withValidated());
    const value = this.state.value;
    if (value === undefined) {
      this.formRef?.focusError();
      return;
    }
    this.onValueAdded(value);
    this.close();
  }
}
